// src/api/endpoints/clients.ts
import api from '../client';
import { Client, ApiResponse, PaginationInfo } from '@/types';

interface ClientsApiResponse extends ApiResponse<Client[]> {
  clients: Client[];
  pagination: PaginationInfo;
}

interface ClientApiResponse extends ApiResponse<{ client: Client }> {}

export const clientsApi = {
  // Get clients with pagination and filters
  getClients: (params?: {
    page?: number;
    limit?: number;
    search?: string;
    isActive?: boolean;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
  }) => api.get<ClientsApiResponse>('/clients', { params }),

  // Get single client with stats
  getClient: (id: string) => api.get<ApiResponse<{
    client: Client;
    stats: {
      tasks: Array<{ _id: string; count: number }>;
      invoices: Array<{ _id: string; count: number; totalAmount: number }>;
    };
  }>>(`/clients/${id}`),

  // Create client
  createClient: (data: Partial<Client>) => api.post<ClientApiResponse>('/clients', data),

  // Update client
  updateClient: (id: string, data: Partial<Client>) => api.put<ClientApiResponse>(`/clients/${id}`, data),

  // Delete client (soft delete)
  deleteClient: (id: string) => api.delete<ApiResponse<null>>(`/clients/${id}`),

  // Get client tasks
  getClientTasks: (id: string) => api.get<ApiResponse<{ tasks: any[] }>>(`/clients/${id}/tasks`),

  // Get client invoices
  getClientInvoices: (id: string) => api.get<ApiResponse<{ invoices: any[] }>>(`/clients/${id}/invoices`),

  // Import clients
  importClients: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post<ApiResponse<{
      imported: number;
      failed: number;
      errors: string[];
    }>>('/clients/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  // Export clients
  exportClients: (format: 'csv' | 'excel' = 'csv') => 
    api.get('/clients/export', {
      params: { format },
      responseType: 'blob'
    }),
};